import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { Mixpanel } from "../config/Mixpanel"
import constants from "../utilities/constants"
import { axiosAuth, axiosNoAuth } from "../config/axiosInstances"
import { API_XANO_CERTIFIED_BASE_URL } from "../config/api_config"
import { Api_url } from "../common/api_url"

const initialState = {
    threeCertificates: false, 
    fiveCertificates: false, 
    sevenCertificates: false, 
    proMembershipSelected: false, 
    personalisedSelected: false, 
    fourWeekPlacementFeature: false,
    showFourWeekPlacementCard: false,
    price: {},
    utm_source: '',
    showNewPersonaliseAndProMembershipModal: false,
    currentTab: 'personalise',
    newShowPlacementSupportModal: false,
    showScanner: false,
    visitedAnalysisCartPage: false,
    showNewCourseSyllabusModal: false,
    makePersonaliseCourseFree: false,
    logoDetails: [],
    showScannerScreen: true,
    rating: 5,
    student: 0,
    skillName: '',
    maxSalary: 0,
    minSalary: 0,
    weeklyRank:{},
    findMoreClicked: false,
    fromSavedAnalysisPage: false,
    showRecognisedSection: false,
    recognisedSectionModalDetails: {},
    recognisedSectionModalIndex: -1,
    showRedirectionModal: false,
    showBadge: false,
    tagsInThisSubject: []
}

export const getLogoAndSalary = createAsyncThunk(
    'getLogoAndSalary',
    async ({ subject, score  }) => {
        try {
            const response = await axiosAuth.get(API_XANO_CERTIFIED_BASE_URL + Api_url.GetSalaryAndLogo, {
                params: {
                    subject, score
                }
            })
            return response.data
        } catch (error) {
            throw error
        }
    }
)

export const getWeeklyRanking = createAsyncThunk(
    'getWeeklyRanking',
    async ({ subject, email }) => {
        try {
            const response = await axiosAuth.post('https://certified-backend.learntube.ai/weekly-score', {
                subject, email
            })
            return response.data?.weekly_stats
        } catch (error) {
            throw error
        }
    }
)

export const sendUserDetailsForWhatsAppShare = createAsyncThunk(
    'sendUserDetailsForWhatsAppShare',
    async ({ certified_user_skill_id, name, phone_number, skill_name }) => {
        try {
            const response = await axiosNoAuth.post('https://xgfy-czuw-092q.m2.xano.io/api:JBnmMhcO/certified_bot/user_resume/add', {
                certified_user_skill_id, name, phone_number, skill_name
            })
            return response.data
        } catch (error) {
            console.log(error)
        }
    }
)

const addOnSlice = createSlice({
    name: 'addOn-selected',
    initialState,
    reducers: {
        setThreeCertificates: (state, action) => {
            state.threeCertificates = action.payload
        },
        setFiveCertificates: (state, action) => {
            state.fiveCertificates = action.payload
        },
        setSevenCertificates: (state, action) => {
            state.sevenCertificates = action.payload
        },
        handleBundles: (state, action) => {
            if (action.payload === 1){
                if(state.threeCertificates){
                    Mixpanel.track(constants.Mixpanel.NEW_ADDON_FEATURE_CERTIFICATES_THREE_CERTIFICATES_REMOVED)
                    state.threeCertificates = false
                }else{
                    Mixpanel.track(constants.Mixpanel.NEW_ADDON_FEATURE_CERTIFICATES_THREE_CERTIFICATES_SELECTED)
                    state.threeCertificates = true
                }    
                state.fiveCertificates = false
                state.sevenCertificates = false
                
            }else if (action.payload === 2){
                if(state.fiveCertificates){
                    Mixpanel.track(constants.Mixpanel.NEW_ADDON_FEATURE_CERTIFICATES_FIVE_CERTIFICATES_REMOVED)
                    state.fiveCertificates = false
                }else{
                    Mixpanel.track(constants.Mixpanel.NEW_ADDON_FEATURE_CERTIFICATES_FIVE_CERTIFICATES_SELECTED)
                    state.fiveCertificates = true
                }
                state.threeCertificates = false
                state.sevenCertificates = false
            }else {
                if(state.sevenCertificates){
                    Mixpanel.track(constants.Mixpanel.NEW_ADDON_FEATURE_CERTIFICATES_SEVEN_CERTIFICATES_REMOVED)
                    state.sevenCertificates = false
                }else{
                    Mixpanel.track(constants.Mixpanel.NEW_ADDON_FEATURE_CERTIFICATES_SEVEN_CERTIFICATES_SELECTED)
                    state.sevenCertificates = true
                }
                state.threeCertificates = false
                state.fiveCertificates = false
            }
        },
        setPrice: (state, action) => {
            state.price = action.payload
        },
        setAnalysisPageUtmSource: (state, action) => {
            state.utm_source = action.payload
        },
        setProMembershipSelected: (state) => {
            if (state.proMembershipSelected){
                Mixpanel.track(constants.Mixpanel.NEW_ADDON_FEATURE_PERSONAL_AND_PRO_MEMBERSHIP_PRO_MEMBERSHIP_COURSE_REMOVED)
            }else{
                Mixpanel.track(constants.Mixpanel.NEW_ADDON_FEATURE_PERSONAL_AND_PRO_MEMBERSHIP_PRO_MEMBERSHIP_COURSE_SELECTED)
            }
            state.proMembershipSelected = !state.proMembershipSelected
        },
        setFourWeekPlacementFeature: (state) => {
            if (state.fourWeekPlacementFeature){
                Mixpanel.track(constants.Mixpanel.NEW_ADDON_FEATURE_PERSONAL_AND_PRO_MEMBERSHIP_FOUR_WEEK_PLACEMENT_REMOVED)
            }else{
                Mixpanel.track(constants.Mixpanel.NEW_ADDON_FEATURE_PERSONAL_AND_PRO_MEMBERSHIP_FOUR_WEEK_PLACEMENT_SELECTED)
            }
            state.fourWeekPlacementFeature = !state.fourWeekPlacementFeature
            state.showFourWeekPlacementCard = true
        },
        setPersonalisedSelected: (state) => {
            if (state.personalisedSelected){
                Mixpanel.track(constants.Mixpanel.NEW_ADDON_FEATURE_PERSONAL_AND_PRO_MEMBERSHIP_PERSONALISED_COURSE_REMOVED)
            }else {
                Mixpanel.track(constants.Mixpanel.NEW_ADDON_FEATURE_PERSONAL_AND_PRO_MEMBERSHIP_PERSONALISED_COURSE_SELECTED)
            }
            state.personalisedSelected = !state.personalisedSelected
        },
        setShowNewPersonaliseAndProMembershipModal: (state, action) => {
            state.showNewPersonaliseAndProMembershipModal = action.payload
        },
        setCurrentTab: (state, action) => {
            state.currentTab = action.payload
        },
        setNewShowPlacementSupportModal: (state, action) => {
            state.newShowPlacementSupportModal = action.payload
        },
        setShowScanner: (state, action) => {
            state.showScanner = action.payload
        },
        setVisitedAnalysisCartPage: (state, action) => {
            state.visitedAnalysisCartPage = action.payload
        },
        setShowNewCourseSyllabusModal: (state, action) => {
            state.showNewCourseSyllabusModal = action.payload
        },
        setMakePersonaliseCourseFree: (state, action) => {
            state.makePersonaliseCourseFree = action.payload
        },
        setShowScannerScreen: (state, action) => {
            state.showScannerScreen = action.payload
        },
        setRating: (state, action) => {
            state.rating = action.payload
        },
        setStudent: (state, action) => {
            state.student = action.payload
        },
        setSkillName: (state, action) => {
            state.skillName = action.payload
        },
        setFindMoreClicked: (state, action) => {
            state.findMoreClicked = action.payload
        },
        setFromSavedAnalysisPage: (state, action) => {
            state.fromSavedAnalysisPage = action.payload
        },
        setShowRecognisedSection: (state, action) => {
            state.showRecognisedSection = action.payload
        },
        setRecognisedSectionModalDetails: (state, action) => {
            const { item, originalIndex } = action.payload
            state.recognisedSectionModalDetails = item
            state.recognisedSectionModalIndex = originalIndex
        },
        setShowRedirectionModal: (state, action) => {
            state.showRedirectionModal = action.payload
        },
        setShowBadge: (state, action) => {
            state.showBadge = action.payload
        },
        setTagsInThisSubject: (state, action) => {
            if(!state.tagsInThisSubject){
                state.tagsInThisSubject = []
            }
            if(!state.tagsInThisSubject?.includes(action.payload)){
                state.tagsInThisSubject.push(action.payload)
            }
        },
        resetAddOnDetails: () => initialState
    },
    extraReducers: (builder) => {
        builder
            .addCase(getLogoAndSalary.fulfilled, (state, action) => {
                state.logoDetails = action.payload?.data
                state.maxSalary = action.payload?.global_high
                state.minSalary = action.payload?.global_low
            })
            .addCase(getWeeklyRanking.fulfilled, (state, action) => {
                state.weeklyRank = action.payload
            })
    }
})

export const { handleBundles, setPrice, setAnalysisPageUtmSource, setProMembershipSelected, setFourWeekPlacementFeature, setPersonalisedSelected, setThreeCertificates, setFiveCertificates, setSevenCertificates, setShowNewPersonaliseAndProMembershipModal, setCurrentTab, setNewShowPlacementSupportModal, setShowScanner, setVisitedAnalysisCartPage, setShowNewCourseSyllabusModal, setMakePersonaliseCourseFree, setShowScannerScreen, setRating, setSkillName, setStudent, resetAddOnDetails, setFindMoreClicked, setFromSavedAnalysisPage, setShowRecognisedSection, setRecognisedSectionModalDetails, setShowRedirectionModal, setShowBadge, setTagsInThisSubject } = addOnSlice.actions

export const selectAddOns = (state) => state.addOns
export const selectPrice = (state) => state.addOns.price
export const selectAnalysisPageUtmSource = (state) => state.addOns.utm_source
export const selectShowNewPersonaliseAndProMembershipModal = (state) => state.addOns.showNewPersonaliseAndProMembershipModal
export const selectCurrentTab = (state) => state.addOns.currentTab
export const selectNewShowPlacementSupportModal = (state) => state.addOns.newShowPlacementSupportModal
export const selectShowScanner = (state) => state.addOns.showScanner
export const selectVisitedAnalysisCartPage = (state) => state.addOns.visitedAnalysisCartPage
export const selectShowNewCourseSyllabusModal = (state) => state.addOns.showNewCourseSyllabusModal
export const selectMakePersonaliseCourseFree = (state) => state.addOns.makePersonaliseCourseFree
export const selectLogoDetails = (state) => state.addOns.logoDetails
export const selectShowScannerScreen = (state) => state.addOns.showScannerScreen
export const selectShowFourWeekPlacementCard = (state) => state.addOns.showFourWeekPlacementCard
export const selectShowRecognisedSection = (state) => state.addOns.showRecognisedSection
export const selectRecognisedSectionModalDetails = (state) => state.addOns.recognisedSectionModalDetails
export const selectRecognisedSectionModalIndex = (state) => state.addOns.recognisedSectionModalIndex
export const selectShowRedirectionModal = (state) => state.addOns.showRedirectionModal
export const selectShowBadge = (state) => state.addOns.showBadge
export const selectTagsInThisSubject = (state) => state.addOns.tagsInThisSubject

export default addOnSlice.reducer